// extracted by mini-css-extract-plugin
module.exports = {"buttonMoons":"ButtonMoons_buttonMoons__3CJ-D","spinner":"ButtonMoons_spinner__1OVY_"};